<template>
  <!-- BUG FIX: <form action=""> sin @submit.prevent causaba recarga de página.
       Se agrega @submit.prevent y se mueve la lógica al submit del form. -->
  <form @submit.prevent="guardarCotizacion">
    <div class="modal-card dialogo-cotiza">
      <header class="modal-card-head cotiza-head">
        <div class="head-content">
          <b-icon icon="ticket-outline" size="is-small" />
          <p class="modal-card-title">Nueva cotización</p>
        </div>
        <button type="button" class="delete" @click="$emit('close', 'cotiza')" />
      </header>

      <section class="modal-card-body">
        <busqueda-cliente @seleccionado="onSeleccionado" />

        <b-field class="mt-3" label="Válido hasta">
          <b-input type="date" v-model="hasta" icon="calendar" required />
        </b-field>

        <!-- Resumen -->
        <div class="cotiza-resumen">
          <span class="resumen-label">Total de la cotización</span>
          <span class="resumen-total">${{ formatoMonto(totalVenta) }}</span>
        </div>
      </section>

      <footer class="modal-card-foot dialogo-foot">
        <b-button label="Cancelar" icon-left="cancel" size="is-small" @click="$emit('close', 'cotiza')" />
        <b-button
          label="Guardar cotización"
          type="is-warning"
          icon-left="ticket-outline"
          size="is-small"
          native-type="submit"
        />
      </footer>
    </div>
  </form>
</template>

<script>
import BusquedaCliente from '../Clientes/BusquedaCliente'
import Utiles from '../../Servicios/Utiles'

export default {
  name: 'DialogoCotizar',
  components: { BusquedaCliente },
  props: ['totalVenta'],

  data: () => ({
    cliente: {},
    hasta: null
  }),

  methods: {
    formatoMonto (valor) {
      return Utiles.formatoMonto(valor)
    },
    onSeleccionado (cliente) {
      this.cliente = cliente
    },
    guardarCotizacion () {
      if (Object.keys(this.cliente).length === 0) {
        this.$buefy.toast.open({ type: 'is-danger', message: 'Debes seleccionar un cliente.' })
        return
      }
      if (!this.hasta) {
        this.$buefy.toast.open({ type: 'is-danger', message: 'Debes agregar una fecha de validez.' })
        return
      }
      this.$emit('terminar', {
        tipo: 'cotiza',
        cliente: this.cliente,
        hasta: this.hasta
      })
    }
  }
}
</script>

<style scoped>
.dialogo-cotiza { width: 480px; max-width: 95vw; }
.head-content { display: flex; align-items: center; gap: 0.5rem; }
.cotiza-head { border-bottom: 2px solid var(--color-accent) !important; }
.cotiza-resumen {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  background: var(--color-surface2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 0.75rem 1rem;
  margin-top: 1rem;
}
.resumen-label {
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: var(--color-text-muted);
}
.resumen-total {
  font-size: 1.4rem;
  font-weight: 800;
  font-family: var(--font-mono);
  color: var(--color-accent);
  letter-spacing: -0.02em;
}
.dialogo-foot { justify-content: flex-end; gap: 0.5rem; }
</style>
